var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HomeLogin"},[_c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Login or Register")])])],1),_c('v-row',[_c('v-col',[_c('LoginForm')],1),_c('v-spacer'),_c('v-col',[_c('RegisterForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }